export default {
  store: {
    getCompletionStatus: "/{__id__}/CompletionStatus",
    changeActiveStatus: "/{__id__}/ChangeActiveStatus",
    dashboard: "/{__id__}/reports/dashboard",
    updateMenuStyle: "/{__storeId__}/updateMenuStyle",
    info: "/{__storeId__}/info",
    updateInfo: "/{__storeId__}/updateInfo",
    categoryIconList: "/{__storeId__}/CategoryIcon/list",
    category: "/{__storeId__}/Category",
    editCategories: "/{__storeId__}/Category/{__id__}",
    changeActiveStatusCategory:
      "/{__storeId__}/Category/{__id__}/changeActiveStatus",
    changeShowInMenuCategory: "/{__storeId__}/Category/{__id__}/showInMenu",
    changeOrderCategory: "/{__storeId__}/Category/{__id__}/changeOrder",
    deleteCategories: "/{__storeId__}/Category/{__id__}",
    addImage: "/{__storeId__}/addImage",
    removeImage: "/{__storeId__}/removeImage",
    updateWorkSchedule: "/{__storeId__}/updateWorkSchedule",
    subscriptionInfo: "/{__storeId__}/subscription/info",
    subscriptionRenewal: "/{__storeId__}/subscription/renewal",
    subscriptionUpgradeDetails: "/{__storeId__}/subscription/upgrade/details",
    subscriptionUpgrade: "/{__storeId__}/subscription/upgrade",
    subscriptionHistory: "/{__storeId__}/subscription/history",
    allProducts: "/{__storeId__}/allProducts",
    productAll: "/{__storeId__}/Product/all",
    productBatch: "/{__storeId__}/Product/batch",
    product: "/{__storeId__}/Product",
    productbyCategory: "/{__storeId__}/Product/byCategory",
    editProduct: "/{__storeId__}/Product/{__id__}",
    changeActiveStatusProduct:
      "/{__storeId__}/Product/{__id__}/changeActiveStatus",
    changeShowInMenuProduct: "/{__storeId__}/Product/{__id__}/showInMenu",
    changeOrderProduct: "/{__storeId__}/Product/changeOrder",
    deleteProduct: "/{__storeId__}/Product/{__id__}",
    changeAvailableStatusProduct:
      "/{__storeId__}/Product/ChangeAvailableStatus",
    changeSpecialStatusProduct: "/{__storeId__}/Product/ChangeSpecialStatus",
    tickets: "/{__storeId__}/tickets",
    detailsTicket: "/{__storeId__}/tickets/{__id__}",
    replyTicket: "/{__storeId__}/tickets/{__id__}/reply",
    closeTicket: "/{__storeId__}/tickets/{__id__}/close",
    changePassword: "/auth/{__storeId__}/changePassword",
    economicInfo: "/{__storeId__}/economicInfo",
    ordersCreate: "/{__storeId__}/orders/create",
    preInvoiceCreate: "/{__storeId__}/orders/preorder",
    ordersToday: "/{__storeId__}/orders/today",
    ordersHistory: "/{__storeId__}/orders/history",
    ordersReport: "/{__storeId__}/orders/report",
    ordersPreorderFind: "/{__storeId__}/orders/preorder/find",
    ordersPreorderEdit: "/{__storeId__}/orders/preorder/{__id__}",
    orderReturn: "/{__storeId__}/orders/{__id__}/return",
    orderDetails: "/{__storeId__}/orders/{__id__}/details",
    orderDetailsStoreOrderNumber: "/{__storeId__}/orders/find",
    orderOnlinePayments: "/{__storeId__}/orders/onlinePayments",
    ordersForSyncPrint: "/{__storeId__}/orders/ordersForSyncPrint",
    productSalesReport: "/{__storeId__}/product/salesReport",
    productPrinterStatus: "/{__storeId__}/product/printerStatus",
    customersWalletTransactions: "/{__storeId__}/customers/walletTransactions",
    customersAddWalletBalance: "/{__storeId__}/customers/addWalletBalance",
    customersSetWalletBalance: "/{__storeId__}/customers/setWalletBalance",
    customerComments: "/{__storeId__}/CustomerComments",
    customerCommentsStatus: "/{__storeId__}/CustomerComments/{__id__}/status",
    customerCommentsSettings: "/{__storeId__}/CustomerComments/settings",
    customersFind: "/{__storeId__}/customers/find",
    customers: "/{__storeId__}/customers",
    customersScoreRecords: "/{__storeId__}/customers/scoreRecords",
    customersImportFromExcel: "/{__storeId__}/customers/importFromExcel",
    editCustomer: "/{__storeId__}/customers/{__id__}",
    editScoreCustomer: "/{__storeId__}/customers/{__id__}/score",
    ordersCustomer: "/{__storeId__}/customers/{__id__}/orders",
    updatePreparationStatus:
      "/{__storeId__}/orders/{__id__}/updatePreparationStatus",
    users: "/{__storeId__}/users",
    usersId: "/{__storeId__}/users/{__id__}",
    loyaltySystem: "/{__storeId__}/loyaltySystem",
    smsManagement: "/{__storeId__}/smsManagement/templates",
    smsChargesHistory: "/{__storeId__}/smsManagement/chargesHistory",
    smsCharge: "/{__storeId__}/smsManagement/charge",
    sentMessagesHistory: "/{__storeId__}/smsManagement/sentMessages",
    smsSchedules: "/{__storeId__}/smsSchedules",
    smsSchedulesById: "/{__storeId__}/smsSchedules/{__id__}",
    smsSchedulesCancel: "/{__storeId__}/smsSchedules/{__id__}/cancel",
    printerCertificates: "/{__storeId__}/printerCertificates",
    printerSignatureMessage:
      "/{__storeId__}/printerCertificates/{__id__}/SignatureMessage",
    printerCertificateKey:
      "/{__storeId__}/printerCertificates/{__id__}/CertificateKey",
    printerCertificatesId: "/{__storeId__}/printerCertificates/{__id__}",
    printers: "/{__storeId__}/printers",
    printersById: "/{__storeId__}/printers/{__id__}",
    userInfo: "/auth/{__storeId__}/userInfo",
    changeDefaultPrinter: "/auth/{__storeId__}/changeDefaultPrinter",
    sendPrintOrderMessage:
      "/{__storeId__}/orders/{__id__}/sendPrintOrderMessage",
    generalReports: "/{__storeId__}/reports/general",
    warehousingCategories: "/{__storeId__}/warehousing/categories",
    warehousingCategoriesById: "/{__storeId__}/warehousing/categories/{__id__}",
    warehousingMaterials: "/{__storeId__}/warehousing/materials",
    warehousingMaterialsById: "/{__storeId__}/warehousing/materials/{__id__}",
    warehousingMaterialsForProducts:
      "/{__storeId__}/warehousing/materials/for-products",
    warehousingWarehouses: "/{__storeId__}/warehousing/warehouses",
    warehousingWarehousesById: "/{__storeId__}/warehousing/warehouses/{__id__}",
    warehousingPeople: "/{__storeId__}/warehousing/people",
    warehousingPeopleById: "/{__storeId__}/warehousing/people/{__id__}",
    warehousingInvoices: "/{__storeId__}/warehousing/invoices",
    warehousingInvoicesById: "/{__storeId__}/warehousing/invoices/{__id__}",
    warehousingStockTakings: "/{__storeId__}/warehousing/stockTakings",
    warehousingStockTakingsById:
      "/{__storeId__}/warehousing/stockTakings/{__id__}",
    warehousingStockTakingsFinalize:
      "/{__storeId__}/warehousing/stockTakings/{__id__}/finalize",
    warehousingStockMovements: "/{__storeId__}/warehousing/stockMovements",
    campaigns: "/{__storeId__}/campaigns",
    campaignsById: "/{__storeId__}/campaigns/{__id__}",
    campaignChangeStatus: "/{__storeId__}/campaigns/{__id__}/status",
    campaignsActives: "/{__storeId__}/campaigns/actives",
    customerCampaign: "/{__storeId__}/campaigns/customer/{__customerId__}/ids",
    tables: "/{__storeId__}/tables",
    tablesActive: "/{__storeId__}/tables/active",
    tablesById: "/{__storeId__}/tables/{__id__}",
  },
  storeRegistration: {
    registerStore: "/RegisterStore/{__storeId__}",
    confirmAdminIdentity: "/ConfirmAdminIdentity/{__storeId__}",
  },
};
